import type { LedgerReturnType } from '@/api/types';

interface TypeFilterProps {
    /** Currently selected filter value (null = All). */
    value: LedgerReturnType | null;
    /** Callback when filter changes. */
    onChange: (value: LedgerReturnType | null) => void;
}

/**
 * Filter component for selecting return type (All/Inflows/Outflows).
 * Styled as a button group with active state indication.
 */
export function TypeFilter({ value, onChange }: TypeFilterProps) {
    const options: { label: string; value: LedgerReturnType | null }[] = [
        { label: 'All', value: null },
        { label: 'Inflows', value: 'inflow' },
        { label: 'Outflows', value: 'outflow' },
    ];

    return (
        <div className="inline-flex rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-secondary p-1">
            {options.map((option) => {
                const isActive = value === option.value;
                return (
                    <button
                        key={option.label}
                        type="button"
                        onClick={() => onChange(option.value)}
                        className={`
                            px-4 py-1.5 text-sm font-medium rounded-md transition-colors
                            ${
                                isActive
                                    ? 'bg-accent dark:bg-primary-light text-white'
                                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark'
                            }
                        `}
                        aria-pressed={isActive}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
